export interface PermissionRequirement {
  permission?: string;
  permissions?: readonly string[];
  requireAll?: boolean;
}

export function hasRequiredPermissions(
  grantedPermissions: readonly string[],
  requirement: PermissionRequirement,
): boolean {
  if (requirement.permission) {
    return grantedPermissions.includes(requirement.permission);
  }

  const required = requirement.permissions ?? [];
  if (required.length === 0) {
    return true;
  }

  return requirement.requireAll
    ? required.every((permission) => grantedPermissions.includes(permission))
    : required.some((permission) => grantedPermissions.includes(permission));
}
